module.exports = "/_next/static/resources/photo-4-82662a1862e8a150fcc74070ac4ea09f.jpg";